import { render, staticRenderFns } from "./CandidateCbrUser.vue?vue&type=template&id=a9938bb2&scoped=true&lang=pug&"
import script from "./CandidateCbrUser.vue?vue&type=script&lang=js&"
export * from "./CandidateCbrUser.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCbrUser.vue?vue&type=style&index=0&id=a9938bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9938bb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VCheckbox,VListItemContent})
